import base from '../dr-base'
import drSnippet from './dr-snippet.vue'

const schema = {
  $Type: 'dr-snippet',
  name: 'Snippet',
  group: 'Common widgets',
  icon: 'archive',
  ...base,
  properties: {
    ...base.properties,
    CurrentTemplate: {
      name: 'vuetifyWidgets.dr-snippet.currentTemplate',
      type: 'string',
      component: 'dr-snippet-select',
      default: ''
    }
  }
}

export default {
  schema,
  component: drSnippet,
  propEditors: [
    {
      name: 'dr-snippet-select'
    }
  ]
}